import type { ApprovalRouteName } from '@/shared/common/types/approvalRoutes.type';

/**
 * Vive en `shared/` porque `shared/layouts/MenuRoute` navega a estas rutas y
 * `shared/` no puede importar de `modules/`.
 * Molde: `*_ROUTE_NAMES` (nombre → string) y `*_ROUTE_PATHS` indexado por nombre.
 * Ver `docs/architecture/routing-guidelines.md`.
 */
export const APPROVAL_ROUTE_NAMES = {
  LIST: 'transaction-approval',
  APPROVE: 'approve',
  APPROVE_TRANSACTION: 'approve-transaction',
  MULTI_APPROVAL_SUMMARY: 'multi-approve-summary',
} as const;

export const APPROVAL_ROUTE_PATHS = {
  [APPROVAL_ROUTE_NAMES.LIST]: '/transaction-approval',
  [APPROVAL_ROUTE_NAMES.APPROVE]: '/approve',
  [APPROVAL_ROUTE_NAMES.APPROVE_TRANSACTION]: ':id/:type',
  [APPROVAL_ROUTE_NAMES.MULTI_APPROVAL_SUMMARY]: '/multi-approve',
} as const satisfies Record<ApprovalRouteName, string>;
